import React, { useState } from "react";
import { EVENT_TYPES } from '../../constants/eventTypes';

function EventGoerSignupModal({ onClose, onSuccess, defaultEmail, defaultName, onGoToDashboard }) {
  const [form, setForm] = useState({ name:defaultName||'', email:defaultEmail||'', zip:'', radius:20, eventTypes:[], wantsAlerts:true, frequency:'weekly' });
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [wasUpdate, setWasUpdate] = useState(false);
  const [error, setError] = useState('');
  const set = (k,v) => setForm(f=>({...f,[k]:v}));
  const allTypes = EVENT_TYPES.filter(t=>t!=='Other'&&t!=='Private Party');
  const allSelected = allTypes.every(t=>form.eventTypes.includes(t));
  const toggleType = (t) => setForm(f=>({...f, eventTypes: f.eventTypes.includes(t) ? f.eventTypes.filter(x=>x!==t) : [...f.eventTypes, t]}));
  const toggleAll = () => setForm(f=>({...f, eventTypes: allSelected ? [] : [...allTypes]}));

  const handleSave = async () => {
    if (!form.name || !form.email) { setError('Please enter your name and email.'); return; }
    if (!/^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/.test(form.email)) { setError('Please enter a valid email.'); return; }
    if (!form.zip || !/^\d{5}$/.test(form.zip)) { setError('Please enter a valid 5-digit zip code.'); return; }
    if (form.eventTypes.length === 0) { setError('Please select at least one event type.'); return; }
    setSaving(true); setError('');
    let isNew = true;
    let manageToken = null;
    try {
      const resp = await fetch('/api/event-goer-signup', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: form.name, email: form.email, zip: form.zip, radius: form.radius,
          eventTypes: form.eventTypes, frequency: form.wantsAlerts ? form.frequency : 'none' }),
      });
      if (!resp.ok) { setError('Failed to save. Please try again.'); setSaving(false); return; }
      const body = await resp.json().catch(() => ({}));
      isNew = body.isNew !== false; // default to true if missing
      manageToken = body.manageToken || null;
    } catch (e) { setError('Failed to save. Please try again.'); setSaving(false); return; }
    setWasUpdate(!isNew);
    setSaved(true); setSaving(false);
    // Only send the welcome email on first signup — avoids duplicate emails on re-submission
    if (isNew) {
      fetch('/api/send-guest-welcome', { method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ email:form.email, name:form.name, zip:form.zip, radius:form.radius, eventTypes:form.eventTypes, frequency: form.wantsAlerts ? form.frequency : 'none', manageToken }),
      }).catch(e=>console.error('API call failed:',e));
      // Notify admin of new guest signup
      fetch('/api/send-contact', { method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ name:'System', email:'noreply@southjerseyvendormarket.com', subject:`New Event Guest Signup: ${form.name}`, message:`New event guest signed up:\n\nName: ${form.name}\nEmail: ${form.email}\nZip: ${form.zip}\nRadius: ${form.radius} miles\nEvent Types: ${form.eventTypes.join(', ')}\nFrequency: ${form.wantsAlerts ? form.frequency : 'none'}` }),
      }).catch(e=>console.error('Admin guest notification failed:',e));
    }
    if (onSuccess) onSuccess();
  };

  return (
    <div onClick={onClose} style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.6)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',padding:16}}>
      <div onClick={e=>e.stopPropagation()} style={{background:'#fff',borderRadius:16,maxWidth:500,width:'100%',overflow:'hidden',maxHeight:'90vh',overflowY:'auto'}}>
        <div style={{background:'#1a1410',padding:'20px 28px',textAlign:'center'}}>
          <div style={{fontSize:20,fontWeight:700,color:'#e8c97a',fontFamily:'Playfair Display,serif'}}>Never Miss a Market</div>
          <div style={{fontSize:13,color:'#a89a8a',marginTop:4}}>Get personalized event alerts delivered to your inbox</div>
        </div>
        <div style={{padding:'24px 28px'}}>
          {saved ? (
            <div style={{textAlign:'center',padding:'20px 0'}}>
              <div style={{fontSize:32,marginBottom:8}}>&#10003;</div>
              <div style={{fontSize:16,fontWeight:700,color:'#1a6b3a',marginBottom:8}}>{wasUpdate ? 'Preferences updated!' : "You're signed up!"}</div>
              <div style={{fontSize:14,color:'#7a6a5a',marginBottom:20}}>{wasUpdate ? "We've updated your preferences. You'll keep getting your existing alerts on the new schedule." : (form.wantsAlerts ? `We'll send you a personalized list of upcoming events ${form.frequency === 'weekly' ? 'every week' : 'every two weeks'}.` : 'You can browse upcoming events anytime on our site.')}</div>
              <div style={{display:'flex',gap:8,justifyContent:'center',flexWrap:'wrap'}}>
                {onGoToDashboard && <button onClick={()=>{onClose();onGoToDashboard();}} style={{background:'#c8a850',color:'#1a1410',border:'none',borderRadius:8,padding:'10px 24px',fontSize:14,fontWeight:700,cursor:'pointer',fontFamily:'DM Sans,sans-serif'}}>Go to My Dashboard</button>}
                <button onClick={onClose} style={{background:'#1a1410',color:'#e8c97a',border:'none',borderRadius:8,padding:'10px 24px',fontSize:14,fontWeight:600,cursor:'pointer',fontFamily:'DM Sans,sans-serif'}}>Close</button>
              </div>
            </div>
          ) : (
            <>
              <div className="form-grid" style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:14}}>
                <div className="form-group"><label>Name <span style={{color:'#c0392b'}}>*</span></label><input value={form.name} onChange={e=>set('name',e.target.value)} placeholder="Your name" /></div>
                <div className="form-group"><label>Email <span style={{color:'#c0392b'}}>*</span></label><input type="email" value={form.email} onChange={e=>set('email',e.target.value)} placeholder="you@email.com" /></div>
                <div className="form-group"><label>Zip Code <span style={{color:'#c0392b'}}>*</span></label><input value={form.zip} onChange={e=>set('zip',e.target.value.replace(/\D/g,'').slice(0,5))} placeholder="08033" maxLength={5} /></div>
                <div className="form-group"><label>How Far You'll Travel</label>
                  <select value={form.radius} onChange={e=>set('radius',+e.target.value)}>
                    {[5,10,15,20,30,50].map(r=><option key={r} value={r}>{r} miles</option>)}
                  </select>
                </div>
              </div>
              <div style={{marginBottom:14}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:8}}>
                  <label style={{fontSize:13,fontWeight:600,color:'#1a1410'}}>Event Types You're Interested In <span style={{color:'#c0392b'}}>*</span></label>
                  <button onClick={toggleAll} style={{background:'none',border:'1px solid #c8a850',color:'#c8a850',borderRadius:6,padding:'3px 12px',fontSize:11,fontWeight:600,cursor:'pointer',fontFamily:'DM Sans,sans-serif'}}>{allSelected ? '\u2713 All Selected' : 'Select All'}</button>
                </div>
                <div style={{display:'flex',flexWrap:'wrap',gap:6}}>
                  {allTypes.map(t=>(
                    <button key={t} onClick={()=>toggleType(t)} style={{
                      padding:'6px 14px',borderRadius:20,fontSize:12,fontWeight:600,cursor:'pointer',
                      fontFamily:'DM Sans,sans-serif',border:'1.5px solid',transition:'all 0.15s',
                      background: form.eventTypes.includes(t) ? '#c8a850' : '#fff',
                      color: form.eventTypes.includes(t) ? '#1a1410' : '#7a6a5a',
                      borderColor: form.eventTypes.includes(t) ? '#c8a850' : '#e8ddd0',
                    }}>{t}</button>
                  ))}
                </div>
              </div>
              <div style={{marginBottom:16}}>
                <label style={{fontSize:13,fontWeight:600,color:'#1a1410',display:'block',marginBottom:8}}>Would you like email alerts about upcoming events?</label>
                <div style={{display:'flex',gap:10,marginBottom:form.wantsAlerts?10:0}}>
                  <button onClick={()=>set('wantsAlerts',true)} style={{flex:1,padding:'10px',borderRadius:8,fontSize:13,fontWeight:700,cursor:'pointer',fontFamily:'DM Sans,sans-serif',border:'2px solid',background:form.wantsAlerts?'#fdf9f0':'#fff',borderColor:form.wantsAlerts?'#c8a850':'#e8ddd0',color:'#1a1410'}}>Yes, keep me posted</button>
                  <button onClick={()=>set('wantsAlerts',false)} style={{flex:1,padding:'10px',borderRadius:8,fontSize:13,fontWeight:700,cursor:'pointer',fontFamily:'DM Sans,sans-serif',border:'2px solid',background:!form.wantsAlerts?'#fdf9f0':'#fff',borderColor:!form.wantsAlerts?'#c8a850':'#e8ddd0',color:'#1a1410'}}>No thanks</button>
                </div>
                {form.wantsAlerts && (
                  <div>
                    <label style={{fontSize:12,color:'#7a6a5a',display:'block',marginBottom:6}}>How often?</label>
                    <div style={{display:'flex',gap:10}}>
                      {[{val:'weekly',label:'Every Week'},{val:'biweekly',label:'Every 2 Weeks'}].map(o=>(
                        <button key={o.val} onClick={()=>set('frequency',o.val)} style={{
                          flex:1,padding:'10px',borderRadius:8,fontSize:13,fontWeight:700,cursor:'pointer',
                          fontFamily:'DM Sans,sans-serif',border:'2px solid',
                          background: form.frequency===o.val ? '#fdf9f0' : '#fff',
                          borderColor: form.frequency===o.val ? '#c8a850' : '#e8ddd0',
                          color:'#1a1410',
                        }}>{o.label}</button>
                      ))}
                    </div>
                  </div>
                )}
              </div>
              {error && <div style={{color:'#c0392b',fontSize:13,marginBottom:12,background:'#fdecea',border:'1px solid #f5c6c6',borderRadius:8,padding:'8px 12px'}}>{error}</div>}
              <button onClick={handleSave} disabled={saving} style={{width:'100%',background:'#c8a850',color:'#1a1410',border:'none',borderRadius:8,padding:'12px 0',fontSize:15,fontWeight:700,cursor:'pointer',fontFamily:'DM Sans,sans-serif',opacity:saving?0.6:1}}>
                {saving ? 'Signing up...' : 'Get Event Alerts'}
              </button>
              <div style={{fontSize:11,color:'#a89a8a',textAlign:'center',marginTop:8}}>Free forever. Unsubscribe anytime.</div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default EventGoerSignupModal;
